import tw from 'twin.macro';

import { DividerHorizontal16 } from '@/page-src/product/components/divider-horizontal-16';
import { ProductInfoList } from '@/page-src/product/components/product-info-list';
import { useGetDeposits } from '@/page-src/product/pages/deposits/hooks/use-get-deposits';
import { trackClickMoreInfoButtonFinancialProductSearchDetail } from '@/src/events/trackers/product/deposits/product-guid';

export const ProductDepositDetailInfoSection = () => {
  const { result, isValidProduct } = useGetDeposits();
  const { deposit } = result;

  if (deposit.descriptions.length === 0 || !isValidProduct) return null;

  return (
    <div css={tw`bg-white-900`}>
      <DividerHorizontal16 />
      <ProductInfoList
        productInfoList={deposit.descriptions}
        showButton
        clickTracker={trackClickMoreInfoButtonFinancialProductSearchDetail}
      />
    </div>
  );
};
